import {NgModule} from '@angular/core';
import {MergeCustomerSelectComponent} from "~features/customer-merger/pages/merge-customer-select/merge-customer-select.component";
import {MergeCustomerDataComponent} from "~features/customer-merger/components/merge-customer-data/merge-customer-data.component";
import {MergeCustomerFinalComponent} from "~features/customer-merger/components/merge-customer-final/merge-customer-final.component";
import {AssembleDataComponent} from "~features/customer-merger/components/assemble-data/assemble-data.component";
import {ReviewDataComponent} from "~features/customer-merger/components/review-data/review-data.component";
import {CompareDataComponent} from "~features/customer-merger/components/compare-data/compare-data.component";
import {CustomerMergeProcessComponent} from "~features/customer-merger/pages/customer-merge-process/customer-merge-process.component";
import {MergeCustomerService} from "~features/customer-merger/merge-customer.service";
import {CommonModule} from "@angular/common";
import {ModalModule} from "~shared/components/elements/modal.module";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {FormValidationModule} from "~core/components/form-validation/form-validation.module";
import {FormFieldsModule} from "~shared/components/form-fields/form-fields.module";
import {ButtonsModule} from "~shared/components/buttons/buttons.module";
import {DirectivesModule} from "~shared/directives/directives.module";
import {TablesModule} from "~shared/components/tables/tables.module";
import {DragDropModule} from "@angular/cdk/drag-drop";
import {OverlayModule} from "@angular/cdk/overlay";
import {TranslationsModule} from "~shared/translations/translations.module";

/**
 * Module for customer overview section
 */
@NgModule({
  declarations: [
    MergeCustomerSelectComponent,
    MergeCustomerDataComponent,
    MergeCustomerFinalComponent,
    AssembleDataComponent,
    ReviewDataComponent,
    CompareDataComponent,
    CustomerMergeProcessComponent
  ],
  exports: [
    MergeCustomerSelectComponent,
    MergeCustomerDataComponent,
    MergeCustomerFinalComponent,
    AssembleDataComponent,
    ReviewDataComponent,
    CompareDataComponent,
    CustomerMergeProcessComponent
  ],
  providers: [
    MergeCustomerService
  ],
  imports: [
    CommonModule,
    ModalModule,
    ReactiveFormsModule,
    FormValidationModule,
    FormFieldsModule,
    ButtonsModule,
    FormsModule,
    DirectivesModule,
    TablesModule,
    DragDropModule,
    OverlayModule,
    TranslationsModule
  ]
})
export class MergeCustomerModule {
}
